<template>
  <div v-if="Object.keys(getTournaments).length !== 0 && Object.keys(getUser).length !== 0">
    <template v-if="booleanIsGSBehavior">
      <Home />
    </template>
    <template v-else>
      <Widget v-if="getUserType === 0 && isWidgetUrl" />
      <Bets v-if="getUserType === 0 && !isWidgetUrl" />
      <Home v-if="getUserType === 1" />
    </template>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapState} from 'vuex';
export default {
  name: 'AppGol',
  components: {
    Bets: () => import('@/views/Bets.vue'),
    Home: () => import('@/views/Home.vue'),
    Widget: () => import('@/views/Widget.vue'),
  },
  computed: {
    ...mapGetters('loginGeneral', ['getUser', 'getUserType', 'getTournaments']),
    ...mapState('loginGeneral', ['booleanIsGSBehavior']),
    isWidgetUrl() {
      var isG = false;
      if (window.sessionStorage.getItem('IsWidget') !== null) {
        isG = true;
      }
      return isG;
    },
  },
  methods: {
    ...mapActions('loginGeneral', ['storeTournaments']),
  },
  async created() {
    if (this.booleanIsGSBehavior) {
      // this.$router.push('/landing');
      if ((await this.$store.dispatch('loginGeneral/getUserInfoLocal')) && this.$route.name === 'main') {
        await this.$router.push('/landing');
      }
    } else {
      if (this.$route.name) {
        if (this.$route.name.includes('widget')) {
          window.sessionStorage.setItem('IsWidget', true);
          if (this.$route.params.team) {
            window.sessionStorage.setItem('WidgetTeam', this.$route.params.team);
          }
        }
      }
      if (window.sessionStorage.getItem('IsWidget') === null) {
        if (!this.$route.name) {
          if (this.getUserType === 0) {
            this.$router.push('/bets');
          } else {
            this.$router.push('/landing');
          }
        }
      }
    }
    this.storeTournaments();
  },
};
</script>
